<template>
  <div class="scs-select-element">
    <h5 v-if="heading">{{ heading }}</h5>
    <div class="scs-select-heading" @click="toggleOptions">
      <p v-if="selected">
        {{
          formatter
            ? formatter(selected)
            : titleProperty
            ? selected[titleProperty]
            : selected
        }}
      </p>
    </div>
    <!-- todo : add nice transition from top or fade -->
    <div class="scs-select-options" v-if="optionsVisible">
      <p
        v-for="(option, index) in options"
        :key="index"
        @click="selectForm(option)"
      >
        {{
          formatter
            ? formatter(option)
            : titleProperty
            ? option[titleProperty]
            : option
        }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selected: undefined,
      optionsVisible: false,
    };
  },
  computed: {},
  methods: {
    selectForm(option) {
      this.selected = option;
      this.$emit("input", option);
      this.optionsVisible = false;
    },
    toggleOptions() {
      this.optionsVisible = !this.optionsVisible;
    },
  },
  mounted() {
    if (this.initial) {
      this.selectForm(this.initial);
    } else {
      this.selectForm(this.options[0]);
    }
  },
  components: {},
  props: ["options", "titleProperty", "heading", "initial", "formatter"],
  emits: ["input"],
};
</script>
<style scoped>
.scs-select-element {
  position: relative;
  cursor: pointer;
  max-width: 300px;
}

h5 {
  margin: 10px;
  width: 90%;
  text-align: left;
}

.scs-select-heading {
  margin: auto;
  height: 17px;
  padding: 10px 0;

  overflow: hidden;
  white-space: nowrap;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: var(--contrastColor);
  border-radius: 4px;
  color: var(--backgroundColor);
  width: auto;
}

.scs-select-options {
  position: absolute;
  filter: drop-shadow(0px 2px 2px var(--shadow));
  top: calc(100% + 10px);
  width: 100%;
  max-height: 200px;
  overflow: scroll;
  background-color: var(--backgroundColor);
  border-radius: 8px;
  padding: 5px 0;
  z-index: 2;
}

p {
  font-size: 0.75em;
  font-weight: 500;
  margin: 15px;
}

p:hover {
  font-weight: 600;
}
</style>
